import App from './App'
import V1_App from './V2/App'

function nodeEnv() {
    if (process.env.NODE_ENV === 'production') {
        return V1_App;
    }
    else if (process.env.NODE_ENV === 'development') {
        return V1_App;
    }
    else {
        console.error("Please specify which environment you are in.")
    }
}

const App_Env = nodeEnv()

export default App_Env;